module.exports = __webpack_public_path__ + "img/index-qysl3.35b7b8f9.png";